<template>
  <div>
    <div class="header">
      <div class="logo">
        <img src="../../assets/img/logossg.png" />
      </div>
    </div>
    <singleChoice
      :defaultProps="mangerList"
      :showDefaultData="itemInfo"
      type="mangerLister"
      v-if="maskshow && masktype == 'openManger'"
      @sub="onsubManger"
      @shut="onshutManger"
      :includeChild="true"
    ></singleChoice>

    <div class="mask" @click="hidemask" v-if="inshow == true">
      <div class="industrydiv" @click="hideindu($event)">
        <div class="industrydiv_top">
          <div class="header">
            <div class="h4">
              <h4>所属行业</h4>
            </div>
            <div class="shut">
              <div @click="onshut"></div>
            </div>
          </div>
          <div class="search">
            <div class="searchinput">
              <div class="in_boxs">
                <div class="in_box" v-if="checkindividual != ''">
                  <div
                    class="text"
                    :style="'width:' + checkindividual.length * 12 + 'px'"
                  >
                    {{ checkindividual }}
                  </div>
                  <span @click="deletein(checkindividual)">×</span>
                </div>
              </div>
              <span class="centerConter" v-if="checkindividual ==''">请选择职业名称</span>
              <!-- <input type="text" placeholder="请输入职业名称"  /> -->
            </div>
            <div class="searchresult" v-if="searchtext != ''">
              <ul>
                <li
                  v-for="(v, k) in get_list"
                  :key="k"
                  v-if="v.indexOf(searchtext) != -1"
                  :class="v == checkindividual ? 'exist' : ''"
                  @click="oncheck(v)"
                >
                  {{ v }}
                </li>
              </ul>
            </div>
            <button @click="onindustry">确定</button>
          </div>
        </div>
        <div class="industry_main">
          <div class="industrydiv_left">
            <ul>
              <li
                v-for="(v, k) in industrylist"
                :key="k"
                :class="v.id == checkid ? 'checked' : ''"
                @click="onchecked(v.id)"
              >
                <span v-for="(i, j) in v.general.split(',')" :key="j">{{
                  i
                }}</span>
              </li>
            </ul>
          </div>
          <div class="industrydiv_right">
            <ul v-for="(v, k) in industrylist" :key="k" v-if="v.id == checkid">
              <li
                v-for="(i, j) in v.individual"
                :key="j"
                @click="oncheck(i)"
                :class="i == checkindividual ? 'checked' : ''"
              >
                {{ i }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <newdepartments
      titles="选择合同公司"
      :checkdata="checklist"
      v-if="maskshow && masktype == 'newdepartment'"
      type="contractCompany"
      @sub="onsub"
    ></newdepartments>
    <newdepartment
      v-if="maskshow && masktype == 'adddeparts'"
      :checkdata="departData"
    ></newdepartment>
    <el-main>
    <div class="sign adaptation">
      <div class="box">
        <p class="return" @click="$router.go(-1)">返回</p>
        <span class="line">|</span>
        <p class="contract">项目列表</p>
        <span class="lines">></span>
        <p class="contract back" v-if="!edit">添加项目</p>
        <p class="contract back" v-if="edit">编辑项目</p>
      </div>
      <div class="title">
        <p v-if="!edit">添加项目</p>
        <p v-if="edit">编辑项目</p>
      </div>
      <div class="content">
        <el-form
          label-width="120px"
          ref="itemInfo"
          :rules="rules"
          :model="itemInfo"
          label-position="right"
        >
          <div class="item">
            <el-form-item label="项目名称" prop="name" style="margin-bottom:20px">
              <el-input v-model.trim="itemInfo.name" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="所属行业" prop="industryName" style="margin-bottom:20px">
              <el-input
                v-model="itemInfo.industryName"
                placeholder="请输入行业类别"
                @focus="ishow"
                suffix-icon="el-icon-arrow-down"
              >
              </el-input>
              <!-- <el-input v-model="baseInfo.industry_name"></el-input> -->
            </el-form-item>
            <el-form-item label="所属项目经理" prop="manger" style="margin-bottom:20px">
              <el-input
                style="width: 450px"
                v-model="itemInfo.manger"
                placeholder="请选择项目经理"
                @focus="staffshow"
                suffix-icon="el-icon-arrow-down"
              />
            </el-form-item>
            <el-form-item label="选择合同公司" style="margin-bottom:20px">
              <button class="btn" type="button" @click="company" tag="button">
                选择合同公司
              </button>
              <span
                class="sizeCom"
                v-if="
                  this.checklist.contractCompany &&
                  this.checklist.contractCompany.length > 0
                "
              >
                已选择
                <span>{{ this.checklist.contractCompany.length }}</span>
                个合同公司
              </span>
            </el-form-item>
            <el-form-item label="是否使用嗖嗖用工" prop="isUseEem">
                <el-radio-group
                  class="ident"
                  v-model="itemInfo.isUseEem"
                  @change="changeResult">
                  <el-radio class="btn1" label="1">是</el-radio>
                  <el-radio class="btn1" label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
               <el-form-item label="是否使用嗖嗖社保" prop="isUseSheBao">
                <el-radio-group
                  class="ident"
                  v-model="itemInfo.isUseSheBao"
                  @change="changeResultSheBao">
                  <el-radio class="btn1" label="1">是</el-radio>
                  <el-radio class="btn1" label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="是否使用消息通知" prop="isUseNotice">
                <el-radio-group
                  class="ident"
                  v-model="itemInfo.isUseNotice"
                  @change="changeResultNotice">
                  <el-radio class="btn1" label="1">是</el-radio>
                  <el-radio class="btn1" label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="btndiv">
        <button class="btn" type="button" @click="$router.go(-1)" tag="button">
          取消
        </button>
        <button class="btn subbtn" @click="addOrg" type="button">保存</button>
      </div>
    </div>
    </el-main>
  </div>
</template>
<script>
import newdepartments from "../../components/common/departmentandstaff";
import newdepartment from "../../components/common/departmentandstaff";
import singleChoice from "../../components/common/singleChoice";

export default {
  created() {
    this.edit = this.$route.query.edit;
    if (this.edit) {
      this.loadData();
    }
  },
  computed: {
    get_list: function () {
      var arr = [];
      this.industrylist.forEach((c) =>
        c.individual.forEach((t) => arr.push(t))
      );
      return arr;
    },
  },
  watch: {
    filterTexts(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      userId: "",
      mangerList: {},
      contractIds: [],
      filterTexts: "",
      datas: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1",
            },
            {
              id: 6,
              label: "二级 2-2",
            },
          ],
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],

      propsa: {
        value: "id",
        children: "children",
        label: "label",
      },
      searchval: "",
      edit: false,
      staffshows: false,
      maskshow: false,
      masktype: "",
      checklist: {},
      departData: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
        ],
        industryName: [
          {
            required: true,
            message: "请输入行业类别",
            trigger: "change",
          },
        ],
        manger: [
          {
            required: true,
            message: "请选择项目经理",
            trigger: "change",
          },
        ],
      },
      industrylist: [
        {
          id: 15,
          general: "IT,通信,电子,互联网",
          individual: [
            "互联网/电子商务",
            "计算机服务（系统/数据/维护）",
            "计算机硬件",
            "通信/电信运营、增值服务",
            "计算机软件",
            "电子技术/半导体/集成电路",
            "通信/电信/网络设备",
            "网络游戏",
          ],
        },
        {
          id: 16,
          general: "金融业",
          individual: [
            "基金/证券/期货/投资",
            "银行",
            "保险",
            "信托/担保/拍卖/典当",
          ],
        },
        {
          id: 17,
          general: "房地产,建筑业",
          individual: [
            "房地产/建筑/建材/工程",
            "物业管理/商业中心",
            "家居/室内设计/装饰装潢",
          ],
        },
        {
          id: 18,
          general: "商业服务",
          individual: [
            "专业服务/咨询(财会/法律/人力资源等)",
            "中介服务",
            "外包服务",
            "广告/会展/公关/市场推广",
            "检验/检测/认证",
          ],
        },
        {
          id: 19,
          general: "贸易,批发,零售,租赁业 ",
          individual: [
            "快速消费品（食品/饮料/烟酒/日化）",
            "贸易/进出口",
            "租赁服务",
            "耐用消费品（服饰/纺织/皮革/家具/家电等）",
            "零售/批发",
          ],
        },
        {
          id: 20,
          general: "教育,培训",
          individual: ["教育/培训/院校"],
        },
        {
          id: 21,
          general: "生产,加工,制造",
          individual: [
            "汽车/摩托车制造与零配件",
            "加工制造（原料加工/模具）",
            "印刷/包装/造纸",
            "医药/生物工程",
            "航空/航天研究与制造",
            "大型设备/机电设备/重工业",
            "仪器仪表/工业自动化",
            "办公用品及设备",
            "医疗设备/器械",
          ],
        },
        {
          id: 22,
          general: "交通,运输,物流,仓储",
          individual: ["交通/运输/物流/仓储", "航天/航空"],
        },
        {
          id: 23,
          general: "服务业",
          individual: [
            "医疗/护理/美容/保健/卫生服务",
            "旅游/度假/酒店/餐饮",
            "生活服务",
          ],
        },
        {
          id: 24,
          general: "文化,传媒,娱乐,体育",
          individual: ["媒体/出版/影视/文化传播", "娱乐/体育/休闲"],
        },
        {
          id: 25,
          general: "能源,矿产,环保",
          individual: [
            "能源/石油/化工/矿产/地质/采掘/冶炼",
            "电气/电力/水利",
            "环保",
          ],
        },
        {
          id: 26,
          general: "政府,非盈利机构",
          individual: ["政府/公共事业/非盈利机构", "学术/科研"],
        },
        {
          id: 27,
          general: "农,林,牧,渔",
          individual: ["农/林/牧/渔", "跨领域经营"],
        },
        {
          id: 28,
          general: "其他",
          individual: ["其他"],
        },
      ],
      checkid: "1",
      searchtext: "",

      inshow: false,
      checkindividual: "",

      itemInfo: {
        name: "",
        industryName: "",
        manger: "",
        mangerId:'',
        isUseEem:"1",
        isUseSheBao:'1',
        isUseNotice:'1'
      },
    };
  },
  methods: {
    changeResult(e){
      console.log(e)
      this.itemInfo.isUseEem = e;
    },
      changeResultSheBao(e){
      console.log(e)
      this.itemInfo.isUseSheBao = e;
    },
    changeResultNotice(e){
      this.itemInfo.isUseNotice = e;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 加载树列表
    loadData() {
      return this.$axios
        .get("project/info?id=" + this.$route.query.id)
        .then((res) => {
          this.itemInfo.name = res.data.data.project.projectName;
          this.itemInfo.industryName = res.data.data.project.industryName;
          this.itemInfo.manger = res.data.data.project.userName;
          this.itemInfo.mangerId = res.data.data.project.userId;
          this.itemInfo.mobile = res.data.data.project.mobile;
          this.itemInfo.orgName = res.data.data.project.orgName;
          this.checklist.contractCompany = res.data.data.contract;
          this.contractIds = res.data.data.contract.toString();
          this.itemInfo.isUseEem = res.data.data.project.isUseEem.toString();
          this.itemInfo.isUseSheBao = res.data.data.project.isUseSheBao.toString();
          this.itemInfo.isUseNotice = res.data.data.project.isUseNotice.toString();

          


        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    //过滤
    onsearch() {},
    addOrg() {
      if (!this.edit) {
        this.$refs.itemInfo.validate((valid) => {
          if (valid) {
            if (this.contractIds == "") {
              this.$message.error("请选择合同公司");
              return;
            }
            const params = {
              projectName: this.itemInfo.name,
              industryName: this.itemInfo.industryName,
              userId: this.itemInfo.mangerId,
              contractIds: this.contractIds,
              isUseEem: this.itemInfo.isUseEem,
              isUseSheBao:this.itemInfo.isUseSheBao,
              isUseNotice:this.itemInfo.isUseNotice,
            };

            this.$axios.post("/project/add", params).then((res) => {
              if (res.data.status == 1) {
                this.$router.push({
                  path: "/ssgSplat",
                });
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        });
      } else if (this.edit) {
        this.$refs.itemInfo.validate((valid) => {
          if (valid) {
            if (this.userId == "") {
              this.userId = this.itemInfo.mangerId;
            }
            if (this.contractIds == "") {
              this.$message.error("请选择合同公司");
              return;
            }
            const params = {
              projectName: this.itemInfo.name,
              industryName: this.itemInfo.industryName,
              userId: this.userId,
              contractIds: this.contractIds,
              id: this.$route.query.id,
              isUseEem: this.itemInfo.isUseEem,
              isUseSheBao:this.itemInfo.isUseSheBao,
              isUseNotice:this.itemInfo.isUseNotice

            };

            this.$axios.put("/project/update", params).then((res) => {
              if (res.data.status == 1) {
                this.$router.push({
                  path: "/ssgSplat",
                });
                this.$message.success(res.data.message);
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        });
      }
    },
    //项目经理确定
    onsubManger(val) {
      // this.userId = "";
      console.log(val)
      var arr = [];
      this.mangerList = {
        mangerLister: [],
      };
      this.mangerList.mangerLister = val.mangerList;
      for (let i = 0; i < this.mangerList.mangerLister.length; i++) {
        this.itemInfo.mangerId= this.mangerList.mangerLister[i].userId;
        this.itemInfo.manger = this.mangerList.mangerLister[i].name;
      }
      console.log( this.mangerList.mangerLister,this.itemInfo.mangerId)

    },
    onshutManger() {
      this.maskshow = false;
      this.masktype = "openManger";
    },
    //合同公司保存按钮
    onsub(v) {
      this.contractIds = [];
      var arr = [];
      this.checklist = {
        contractCompany: [],
      };
      this.checklist.contractCompany = v.contractCompany;
      this.contractIds = v.contractCompany.toString();

      this.maskshow = false;
      this.masktype = "newdepartment";
    },
    company() {
      this.maskshow = true;
      this.masktype = "newdepartment";
    },
    deletein() {
      this.checkindividual = "";
    },
    oncheck(i) {
      this.checkindividual = i;
      this.searchtext = "";
    },
    onchecked(id) {
      this.checkid = id;
    },
    hidemask() {
      this.inshow = false;
      this.checkindividual = "";
    },
    onindustry() {
      this.itemInfo.industryName = this.checkindividual;
      this.inshow = false;
    },
    onshut() {
      this.inshow = false;
      this.checkindividual = "";
    },
    onshuts() {
      this.staffshows = false;
    },
    hideindu(e) {
      e.stopPropagation();
    },
    ishow() {
      this.inshow = true;
    },
    staffshow() {
      this.maskshow = true;
      this.masktype = "openManger";
    },
    // loadData() {
    //   const params = {};
    //   return this.$axios
    //     .get("group/findGroupListByName", {
    //       params,
    //     })
    //     .then((res) => {
    //       //   this.list = res.data.data.list;
    //       //   this.total = res.data.data.total;
    //       //   if( this.pageNo!==1 && this.list.length==0){
    //       //     this.pageNo = this.pageNo-1
    //       //     this.loadData()
    //       //   }
    //       // this.noticeStatus = res.data.data.noticeStatus -1;
    //     })
    //     .catch((err) => {
    //       //处理错误
    //       console.error(err);
    //     });
    // },
  },
  components: {
    newdepartments,
    newdepartment,
    singleChoice,
  },
};
</script>


<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.el-main {
  height: calc(100vh - 60px);
}
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}

.dataitems {
  width: 55%;
  // padding-left: 12%;
}

.contree {
  width: 100%;
  height: 740px;
  border-radius: 4px;
  border: 1px solid rgba(216, 218, 225, 1);
  display: flex;
}

.trees {
  width: 50%;
  height: 700px;
  overflow-y: auto;
  overflow-x: hidden;

  border-right: 1px solid #d8dae1;
}

.edit {
  width: 50%;
  height: 740px;
  background: rgba(247, 248, 252, 1);
}

.table {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 34px;

  h4 {
    font-size: 14px;
    font-weight: bold;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 8px;
    color: #303140;
  }

  h4:before {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    width: 4px;
    height: 12px;
    background-color: #6669e3;
    border-radius: 4px;
  }
}

.gettree {
  margin-left: 34px;
}

.btndiv {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  .subbtn {
    margin-left: 10px;
  }
}
.content {
  display: flex;
  justify-content: center;
}

.mytree {
  margin-left: 40px;

  .first {
    margin-left: 10px;
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.mytree /deep/ .el-tree {
  > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
    background-color: #eee;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #d8dae1;
    bottom: 0px;
    height: 100%;
    top: -17px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #d8dae1;
    height: 20px;
    top: 21px;
    width: 24px;
  }

  .el-tree .is-current:after {
    background-color: transparent;
  }
}

.edut {
  margin-left: 40px;

  .fontName {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
    margin-bottom: 20px;
  }
}
.header {
  height: 63px;
  background-color: #f2f5f8;
  display: flex;
  align-items: center;
  .logo {
    margin-left: 30px;
  }
}
.sign {
 max-width: 1920px;
  min-width: 1260px;
  // height: 100%;
  padding: 0 50px;
  box-sizing: border-box;

  /*background-color: #fff;
          border: 1px solid #d9dbe2;
          border-radius: 6px 6px 0 0;*/
  .operating {
    width: 100%;
    min-height: 62px;
    line-height: 62px;
    box-sizing: border-box;

    .search {
      margin-right: 14px;
    }
  }
}
.mask {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 15000;
  overflow: hidden;
}
.masks {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 15000;
  overflow: hidden;
}

.industrydiv {
  width: 720px;
  height: 508px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -254px;
  margin-left: -360px;
  border-radius: 6px;
}
.industrydivs {
  width: 900px;
  height: 600px;
  background-color: #fff;
  margin: 50px auto;
  border-radius: 6px;
}

.industrydiv .industrydiv_top {
  width: 100%;
  height: 110px;
  border-bottom: 1px solid #dfdfdf;
  padding: 0 25px;
  box-sizing: border-box;
}
.industrydivs .industrydivs_top {
  height: 71px;
  // border-bottom: 1px solid #dfdfdf;
  padding: 0 25px;
}
.industrydivs .industrydivs_top .headers {
  height: 71px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.industrydivs .industrydivs_top .headers .h4 {
  display: flex;
  .search {
    width: 350px;
    height: 30px;
    display: inline-block;
    line-height: 71px;
    margin-left: 23px;
  }
}

.industrydivs .industrydivs_top .headers .shut {
  width: 20px;
  display: flex;
  flex-direction: row-reverse;
}
.industrydivs .industrydivs_top .headers .shut div {
  width: 12px;
  height: 12px;
  background-image: url(../../assets/img/cha.png);
  background-size: cover;
  cursor: pointer;
}
.industrydivs .industrydivs_top .headers .h4 h4 {
  font-size: 18px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  line-height: 71px;
}
.industrydiv .industrydiv_top .header {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
  background-color: white;
}

.industrydiv .industrydiv_top .header .h4 {
  width: 50%;
}

.industrydiv .industrydiv_top .header .h4 h4 {
  font-size: 18px;
  font-weight: bold;
}

.industrydiv .industrydiv_top .header .shut {
  width: 50%;
  display: flex;
  flex-direction: row-reverse;
}

.industrydiv .industrydiv_top .header .shut div {
  width: 12px;
  height: 12px;
  background-image: url(../../assets/img/cha.png);
  background-size: cover;
  cursor: pointer;
}

.industrydiv .industrydiv_top .search {
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  position: relative;
}

.industrydiv .industrydiv_top .search .searchinput {
  width: 570px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 6px;
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 14px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs {
  display: flex;
  align-items: center;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box {
  width: auto;
  display: flex;
  align-items: center;
  height: 22px;
  background-color: #6669e3;
  color: #fff;
  padding: 0 5px;
  border-radius: 4px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box .text {
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box span {
  cursor: pointer;
  font-size: 18px;
}

.industrydiv .industrydiv_top .search .searchinput input {
  width: 570px;
  height: 32px;
  border-radius: 6px;
  border: none;
  margin: 0 8px;
  box-sizing: border-box;
  font-size: 14px;
  // background-image: url(../../assets/img/ss.png);
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: right center;
}

.industrydiv .industrydiv_top .search button {
  border: none;
  height: 34px;
  padding: 0 15px;
  border-radius: 6px;
  min-width: 84px;
  color: #fff;
  font-size: 14px;
  background-color: #6669e3;
  cursor: pointer;
  float: right;
}

.industrydiv .industrydiv_top .search button:hover {
  background-color: #8285ff;
}

.industrydiv .industrydiv_top .search button:active {
  background-color: #5658c5;
}

.industrydiv .industrydiv_top .search .searchresult {
  width: 568px;
  overflow: auto;
  max-height: 200px;
  background-color: #fff;
  position: absolute;
  top: 33px;
  left: 0;
  border: 1px solid #bfbfbf;
}

.industrydiv .industrydiv_top .search .searchresult ul {
  width: 100%;
  box-sizing: border-box;
}

.industrydiv .industrydiv_top .search .searchresult ul li {
  font-size: 14px;
  padding: 13px;
}

.industrydiv .industrydiv_top .search .searchresult ul li:hover {
  background-color: #f8f8f8;
}

.industrydiv .industrydiv_top .search .searchresult ul .exist {
  color: #6669e3;
}

.industrydiv .industry_main {
  width: 100%;
  height: 395px;
  box-sizing: border-box;
  display: flex;
}
.industrydivs .industry_main {
  width: 100%;
  height: 529px;
  box-sizing: border-box;
  display: flex;
}
.industrydivs .industry_main .industrydiv_left {
  width: 350px;
  height: 529px;
  background: rgba(242, 245, 248, 1);
  box-sizing: border-box;
  .leftContent {
    width: 100%;
    height: 100%;
    overflow: auto;
    padding-top: 20px;
    box-sizing: border-box;
  }
}
.industrydiv .industry_main .industrydiv_left {
  width: 215px;
  height: 100%;
  padding-left: 26px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 20px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul li {
  margin-bottom: 13px;
  cursor: pointer;
}

.industrydiv .industry_main .industrydiv_left ul li span {
  display: inline-block;
  height: 14px;
  line-height: 14px;
  border-right: 1px solid #bfbfbf;
  padding: 0 6px;
  color: #8b8b8b;
  font-size: 14px;
}

.industrydiv .industry_main .industrydiv_left ul li span:last-child {
  border-right: none;
}

.industrydiv .industry_main .industrydiv_left ul li span:first-child {
  padding-left: 0;
}

.industrydiv .industry_main .industrydiv_left ul .checked {
  background-image: url(../../assets/img/bg_yellor.png);
  background-size: 7px auto;
  background-repeat: no-repeat;
  background-position: 178px center;
}

.industrydiv .industry_main .industrydiv_left ul .checked span {
  font-weight: bold;
  color: #000000;
}

.industrydiv .industry_main .industrydiv_right {
  width: 505px;
  height: 100%;
  background-color: #f2f2f5;
}

.industrydiv .industry_main .industrydiv_right ul {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
}

.industrydiv .industry_main .industrydiv_right ul li {
  // display: inline-block;
  width: 45%;
  margin-bottom: 12px;
  cursor: pointer;
  height: 40px;
  margin-right: 10px;
}

.industrydiv .industry_main .industrydiv_right ul .checked {
  color: #6669e3;
}
.ibox .edit[data-v-6c99882d] {
  width: 100%;
  background-color: #f2f5f8;
  padding-top: 40px;
  border-radius: 6px;
}
.centerConter {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #8b8b8b;
}
.title {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  p {
    font-size: 24px;
    font-weight: bold;
    color: rgba(48, 49, 64, 1);
    line-height: 36px;
  }
}
.sizeCom {
  font-size: 12px;
  font-weight: 400;
  color: rgba(84, 85, 102, 1);
  margin-left: 16px;
  span {
    color: #6669e3;
    font-weight: bold;
  }
}
.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 5px 0 0;
  box-sizing: border-box;
}
</style>
